// extracted by mini-css-extract-plugin
export var biograpyContainer = "BiographyBox-module--biograpyContainer--HyUiE";
export var sectionHeadingCls = "BiographyBox-module--sectionHeadingCls--h26d+";
export var boldCls = "BiographyBox-module--boldCls--ROCqk";